import React, { useEffect, useCallback, useState} from 'react';
import {ChromePicker} from 'react-color';
import Modulators from 'components/effects/Modulators.js';
import EffectParameterSlider from "components/effects/EffectParameterSlider.js";
import {connect} from 'react-redux';
import Colors from 'components/Colors.js';
const colors = new Colors();

const MacroInfo = ({setSelectedColor, macro, macroToShow, setMacroToShow}) => { 
    let [showColor, setShowColor] = useState(false);
    let [color, setColor] = useState(macro.color);
    let selected = macro === macroToShow;
    let sequencerEngine = macro.effect.track.sequencerEngine;
    let parameter = macro.signalParameter;

    const onChangeColor = useCallback((color) => {
        macro.color = color.hex;
        setColor(color.hex);
        setSelectedColor(color);
    }, [setSelectedColor, macro, setColor]);

    useEffect(() => {
        setColor(macro.color);
    }, [macro, setColor]);

    return (
        <div
          onMouseDown={e => e.stopPropagation()}
          className="macro-info">
          <div style={{backgroundColor: colors.getColorForHash(macro.id)}} className="macro-indicator"/>
          <div className="macro-name">
            {macro.name}
          </div>
          <Modulators
            parameter={parameter}
            sequencerEngine={sequencerEngine}
            disconnectFromLFO={(x,y) => macro.disconnectFromLFO(x,y)}
            connectToLFO={(x,y) => macro.connectToLFO(x,y)}
          />
          <div
            onClick={() => setShowColor(!showColor)}
            style={{backgroundColor: color}} className={showColor ? "color-btn showing" : "color-btn"}></div> 

          {showColor &&
           <ChromePicker color={color} onChange={onChangeColor}></ChromePicker>}
          <div
            onClick={() => setMacroToShow(selected ? undefined : macro)}
            className={selected ? "selected macro-show-btn" : "macro-show-btn"}>
            {selected ? "Collapse" : "Expand"}
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MacroInfo);
